<template>
    <div class="form-group quick-pay" v-show="isShowExpressCheckout" v-if="!isPaidByGiftCertificate">
        <div class="wrap">
            <h2>Express Checkout</h2>
            <div class="types">
                <template v-for="paymentMethod in getAvailableExpressPaymentMethods">
                    <div class="payment-method">
                        <component :is="paymentMethod.component" :payment-method="paymentMethod"></component>
                    </div>
                    <div class="divider" v-if="isMobile">
                        <span>OR</span>
                    </div>
                </template>
            </div>
        </div>
        <div class="divider" v-if="!isMobile">
            <span>OR</span>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {isMobile} from "@support/helpers";

    export default {
        name: 'expressCheckout',
        props: {
            onlyMobile: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            ...mapGetters('checkout', [
                'checkout',
                'isShowExpressCheckout',
                'isPaidByGiftCertificate',
                'getAvailableExpressPaymentMethods'
            ]),
            isMobile() {
                return isMobile();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .quick-pay {
        .types {
            flex-direction: column;
        }
    }
</style>
